'use client';

import React, { useEffect, useRef, useState } from 'react';

const galleryImages = [
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_16098d1c3-1772593030058.png",
  alt: 'Modern dental office'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1267d0e3a-1772134114388.png",
  alt: 'Dental treatment room'
},
{
  src: "https://images.unsplash.com/photo-1683520701329-e7dbcd3409f0",
  alt: 'Dentist with patient'
},
{
  src: "https://images.unsplash.com/photo-1591283261401-c76eba2d369a",
  alt: 'Dental equipment'
},
{
  src: "https://images.unsplash.com/photo-1728102197400-0648e058fddd",
  alt: 'Dental care'
}];


export default function GalleryStrip() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <div data-component-id="src/components/GalleryStrip.tsx:47:4" data-component-path="src/components/GalleryStrip.tsx" data-component-line="47" data-component-end-line="69" data-component-file="GalleryStrip.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20overflow-hidden%22%7D" ref={ref} className="w-full overflow-hidden">
      <div data-component-id="src/components/GalleryStrip.tsx:48:6" data-component-path="src/components/GalleryStrip.tsx" data-component-line="48" data-component-end-line="68" data-component-file="GalleryStrip.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-5%22%7D" className="grid grid-cols-5">
        {galleryImages?.map((img, idx) =>
        <div data-component-id="src/components/GalleryStrip.tsx:50:8" data-component-path="src/components/GalleryStrip.tsx" data-component-line="50" data-component-end-line="66" data-component-file="GalleryStrip.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
          key={idx}
          className={`img-overlay relative overflow-hidden transition-all duration-700 ${
          isVisible ? 'opacity-100' : 'opacity-0'}`
          }
          style={{
            transitionDelay: `${idx * 100}ms`,
            height: '180px'
          }}>
          
            <img data-component-id="src/components/GalleryStrip.tsx:60:12" data-component-path="src/components/GalleryStrip.tsx" data-component-line="60" data-component-end-line="64" data-component-file="GalleryStrip.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20transition-transform%20duration-500%20hover%3Ascale-110%22%7D"
            src={img?.src}
            alt={img?.alt}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
            loading="lazy" />
          
          </div>
        )}
      </div>
    </div>);

}